<template>
	<section class="view">
		<div class="row ">
			<div v-if="!authorised"  class="offset-5 col-2 entry-pin pin">
				<InputText id="pin" name="Enter your pin" :form="form" :errors="errors" maxLength="4" class="pin-entry" type="password" v-on:enter-pressed="checkPin"/>
				<button class="button-action button-submit" @click="checkPin">Enter</button>
			</div>
		</div>
		<div v-if="authorised" class="board">
			<section class="container-fluid">
				<div class="row">
					<div class="col-12 boardbar">
						<span class="boardbar-label">Date</span>
						<datepicker class="datepicker-input" ref="openPicker" v-model="date"/>
						<button class="calendar-button" @click="openDatePicker">
							<i class="ss-calendar ss-glyphish-filled"></i>
						</button>
						<button class="button-action" @click="print">Print</button>
						<button @click="toggleDetailedView" class="button-transparent button-link">{{ detailedView ? 'Simple View' : 'Detailed View' }}</button>
						<div id="split-toggle" v-if="!detailedView">
							<label>Full</label>
							<toggle-button :sync="true" v-model="splitView" :css-colors="true"/>
							<label>Dual</label>
						</div>
					</div>
				</div>
				<div class="row" v-if="tenant && tenant.hasMultiYard">
					<div class="col-12 boardbar">
						<span class="boardbar-label">Location</span>
						<InputSelect id="id" name="" :options="locations" :form="locationFilter" :errors="{}" class="location-filter"/>
					</div>
				</div>
				<div class="row view-container split-row">
					<div class="col-12">
						<Simple :board="board" v-if="board && !detailedView && splitView === false" :split="false" :locationFilter="locationFilter"/>
						<div class="row split-row" v-if="splitView">
							<div class="col-6 left">
								<Simple :board="board" v-if="board && !detailedView && splitView === true" :split="true" :splitPosition="1" :locationFilter="locationFilter"/>
							</div>
							<div class="col-6 right">
								<Simple :board="board" v-if="board && !detailedView && splitView === true" :split="true" :splitPosition="2" :locationFilter="locationFilter"/>
							</div>
						</div>
						<DetailedView :lots="lots" :board="board" v-if="board && detailedView" :locationFilter="locationFilter"/>
					</div>
				</div>
			</section>
		</div>
	</section>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex'
import InputText from '../Form/InputText.vue'
import board from '../../lib/board'
import Simple from '../Board/Grids/Simple.vue'
import DetailedView from '../Board/Grids/DetailedView.vue'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import VueScrollTo from 'vue-scrollto'
import InputSelect from '../Form/InputSelect.vue'

export default {
	components: {
		InputText,
		Simple,
		Datepicker,
		DetailedView,
		InputSelect
	},
	data() {
		return {
			pin: '',
			authorised: false,
			form: {},
			errors: {},
			board: null,
			date: '',
			detailedView: false,
			pollTime: (2.5 * 60 * 1000),
			splitView: false,
			scrollingSpeed: 500, //higher is slower
			cancelScrolling: null,
			locationFilter: { id: 0 }
		}
	},
	computed : {
		...mapState({
			lots: state => state.lots.list
		}),
		tenant() {
			return this.$store.getters['tenant/get']
		},
		locations() {
			let locations = [{ key: 0, value: 'All Locations' }]
	
			 this.$store.getters['locations/list'].forEach(location => {
				locations.push({
					key: location.id,
					value: location.name
				})
			})

			return locations
		}
	},
	watch: {
		date: function () {
			this.loadBoard(this.date);
		},
		splitView(splitView) {
			window.localStorage.setItem('split', splitView)
			if(this.cancelScrolling) {
				this.cancelScrolling()
				this.autoScroll(true)
			}
		},
	},
	beforeRouteLeave (to, from, next) {
		if(this.cancelScrolling) {
			this.cancelScrolling()
		}
		next()
	},
	methods: {
		checkPin() {
			axios.post(`/api/v1/users/pin/${this.$route.params.tenantId}`, { pin: this.form.pin })
			.then(response => {
				localStorage.setItem('userRole', response.data.user.role)
				this.$store.commit('tenant/set', response.data.tenant)
				this.loadBoard(this.date)
				this.authorised = true
				this.initData()
			})
			.catch(err => {
				if(err.response.status === 403) {
					this.errors = { pin: 'Invalid pin number' }
					this.form.pin = ''
				} else {
					this.$store.dispatch('app/addAlert', {
						type: 'error',
						message: 'An Error occurred, please try later',
						timeout: 3000
					})
				}
			})
		},
		loadBoard(date) {
			date = moment(this.date).format('YYYY-MM-DD')
			board.get(date, true).then(b => {
				this.board = b
				//Call scrolling view
				this.autoScroll(true)
			})
		},
		toggleDetailedView() {
			this.detailedView = !this.detailedView
			this.autoScroll(true)
		},
		print() {
			window.print()
		},
		pollBoard() {
			setTimeout(() => {
				this.loadBoard(this.date)
				this.pollBoard()
			}, this.pollTime)
		},
		openDatePicker() {
			this.$refs.openPicker.showCalendar();
		},
		autoScroll(down) {
			if(this.board.totalRows) {
				const self = this
				const elem = down ? 'footer' : 'header'
				const speed = down ? Math.ceil(this.splitView ? this.board.totalRows * 0.8 : this.board.totalRows) * this.scrollingSpeed : 500
				const options = {
					offset: 0,
					force: true,
					easing: 'ease-in',
					cancelable: true,
					onStart: false,
					x: false,
					y: true,
					onDone (element) {
						self.autoScroll(!down)
					}
				}
				this.cancelScrolling = VueScrollTo.scrollTo(elem, speed, options)
			}
		},
		initData() {
			this.$store.commit('app/setLoading', true)

			const people = this.$store.dispatch('people/getList')
			const horses = this.$store.dispatch('horses/getList')
			const lots = this.$store.dispatch('lots/getList')
			const age = this.$store.dispatch('age/getList')
			const tasks = this.$store.dispatch('tasks/getList')
			const equipment = this.$store.dispatch('equipment/getList')
			const locations = this.$store.dispatch('locations/getList')

			Promise.all([people, horses, lots, age, tasks, equipment, locations])
			.then(() => {
				this.authorised = true;
				this.$store.commit('app/setLoading', false)
				this.pollBoard()
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				if(err.response.status !== 403) {
					this.$store.dispatch('app/addAlert', {
						type: 'error',
						message: 'An Error occurred, please try later',
						timeout: 3000
					})
				}
			});
		}
	},
	mounted() {
		this.splitView = window.localStorage.getItem('split') == 'true'
		this.date = moment().format('D MMM YYYY')
		this.initData()
	}
}
</script>

<style lang="scss">
	.view-container {
		margin-top: 10px;
	}
	.boardbar-label {
		margin-right: 10px;
		font-weight: 600;
	}
	.location-filter {
		display: inline-block;
		width: 350px;
		padding-bottom: 0;
	}
	.pin {
		margin-top: calc(50vh - 200px);
		.pin-entry {
			input {
				min-width: 100%;
				text-align:center;
			}
		}
		button {
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Pages/View.vue